// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"58bce227","97":"63f14e45","147":"f0ba1b2a","234":"9d6b0efb","367":"1c372006","410":"ee8d7572","453":"18a5deb6","501":"80a2ecd0","612":"de504f66","700":"44d47ce2","767":"b3054f19","856":"4f5ba075","869":"a4dcb98a","980":"522d2fcd"}[chunkId] + ".chunk.js";
};